module.exports = __webpack_public_path__ + "seo-facebook.9b3b9ab.jpg";